module.exports = __webpack_public_path__ + "img/bbac3f9ba97c432ba1f056eced71228d-60.0115262e.png";